import React from 'react'

const Frontend = () => {
  return (
    <div className="skills__content">
        <h3 className="skills__title">Front-End & Implementation</h3>

        <div className="skills__box">
            <div className="skills__group">

                <div className="skills__data">
                <i className='bx bx-badge-check'></i>

                    <div>
                        <h3 className="skills__name">HTML</h3>
                        <span className="skills__level">Semantic, accessible markup</span>
                    </div>
                </div>

                <div className="skills__data">
                <i className='bx bx-badge-check'></i>

                    <div>
                        <h3 className="skills__name">CSS</h3>
                        <span className="skills__level">Responsive interfaces</span>
                    </div>
                </div>

                <div className="skills__data">
                <i className='bx bx-badge-check'></i>

                    <div>
                        <h3 className="skills__name">JavaScript</h3>
                        <span className="skills__level">Modern ES6+ development</span>
                    </div>
                </div>

            </div>

            <div className="skills__group">
                <div className="skills__data">
                <i className='bx bx-badge-check'></i>

                    <div>
                        <h3 className="skills__name">TypeScript</h3>
                        <span className="skills__level">Typed front-end workflows</span>
                    </div>

                </div>

                <div className="skills__data">
                <i className='bx bx-badge-check'></i>

                    <div>
                        <h3 className="skills__name">React</h3>
                        <span className="skills__level">Components and applications</span>
                    </div>

                </div>

                <div className="skills__data">
                <i className='bx bx-badge-check'></i>
                    <div>
                        <h3 className="skills__name">CMS & CRM</h3>
                        <span className="skills__level">WordPress, Webflow, GoHighLevel</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Frontend
